export enum DeviceType {
  MOBILE = "mobile",
  TABLET = "tablet",
  DESKTOP = "desktop",
  PC = "pc", // 新增
  OTHER = "other",
  UNKNOWN = "unknown",
}
